import React, { useState, useEffect, useRef } from 'react';
import { SearchMarkingCriteria } from './style';

const SearchItems = ({ placeholderText, searchValue, onSearch }) => {
  const [localValue, setLocalValue] = useState(searchValue || '');
  const isExternalUpdate = useRef(false);

  useEffect(() => {
    if (searchValue !== undefined && searchValue !== localValue) {
      isExternalUpdate.current = true;
      setLocalValue(searchValue);
    }
  }, [searchValue]);

  useEffect(() => {
    if (isExternalUpdate.current) {
      isExternalUpdate.current = false;
      return;
    }
    const timer = setTimeout(() => onSearch(localValue), 250);
    return () => clearTimeout(timer);
  }, [localValue]);

  return (
    <SearchMarkingCriteria
      placeholder={placeholderText}
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
    />
  );
};

export default SearchItems;
